import React from "react";
import { useTheme } from "@mui/material";

import DefaultLink from "../../components/link/DefaultLink";
import UserContainer from "../../components/layout/container/UserContainer";
import SimpleBox from "../../components/layout/container/SimpleBox";

const ValidateEmail = () => {

    const theme = useTheme();

    return (
        <UserContainer
            title="Verificar Email"
            message="A sua conta foi criada com sucesso. Por favor, verifique o seu email para ativar a sua conta. Verifique também a sua caixa de spam. Se não receber o email, por favor, contacte-nos."
        >
            <SimpleBox mt={theme.spacing(6)} justifyContent="center">
                <DefaultLink label="Entrar" to="/login" fontSize="1.1rem" allCaps={true} />
            </SimpleBox>
        </UserContainer>
    );
};

export default ValidateEmail;
